import { forwardRef, useContext } from 'react'
import { Link } from 'react-router-dom'
import { LanguageContext } from './LanguageContext'
import { localizedPath } from '../../config/i18nRoutes'

/**
 * A <Link> that points at the current language's URL when the target page
 * has one: `to='/services'` renders href="/de/services" while German is
 * selected. Without it every link on a /de page pointed at the English URL,
 * so crawlers found no links to the German, French and Spanish pages at all
 * (LocaleUrlSync only corrects the address after a click, in the browser).
 */
const LocaleLink = forwardRef(({ to, ...props }, ref) => {
  const { selectedLanguage } = useContext(LanguageContext)
  const target = typeof to === 'string' ? localizedPath(to, selectedLanguage) : to
  return <Link ref={ref} to={target} {...props} />
})

export default LocaleLink
